class ConnUpdateComponent {
  constructor() {
    this.updating = false;
  }
}

export default {
  bindings: {
    template: "=",
    title: "<",
    ignoreStoredConn: "=?",
    ignoreLeaveConfirm: "=?",
    close: "&?"
  },
  templateUrl: 'form-builder/conn-update/conn-update.component.html',
  controller: ConnUpdateComponent
};